module.exports = __webpack_public_path__ + "static/media/vanilla-profile2.eba7a567.png";